import AppCard from '@crema/core/AppCard'
import { Box, Breadcrumbs, FormControl, Grid, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { onGetSurveyCount, onGetSurveyReport } from 'redux/actions'
import MixPieChart from './MixPieChart'
import ListSurvey from './ListSurvey'
import { useSelector } from 'react-redux'
import { Fonts } from 'shared/constants/AppEnums'
import { LinearProgressBar } from './LinearProgress'
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from 'shared/constants/ActionTypes'
import { getSurveyExport } from '@crema/services/apis/survey'
import axios from 'axios'
import MixBarChart from './MixBarChart'
import AppCircularProgress from '@crema/core/AppCircularProgress'
import { grey } from '@mui/material/colors'
import { COLORS } from 'shared/constants/AppEnums';
import AppInfoView from '@crema/core/AppInfoView';

const HasilSurvey = () => {
    const navigation = useNavigate()
    const dispatch = useDispatch()
    const [dataGraphPenggunaan, setDataGraphPenggunaan] = useState([])
    const [dataGraphJenisPegawai, setDataGraphJenisPegawai] = useState([])
    const [dataGraphJenisKelamin, setDataGraphJenisKelamin] = useState([])
    const [dataGraphUsia, setDataGraphUsia] = useState([])
    const [dataGraphDivision, setDataGraphDivision] = useState([])
    const [dataGraphPendidikan, setDataGraphPendidikan] = useState([])
    const [dataGraphPenilaian, setDataGraphPenilaian] = useState({
        pertanyaan1: [],
        pertanyaan2: [],
        pertanyaan3: [],
        pertanyaan4: [],
        pertanyaan5: [],
        arrRata: [],
        rata: 0
    })
    const [nProgress, setProgress] = useState(0)
    const [loadingProgress, setLoadingProgress] = useState(false)
    const { listCount } = useSelector(state => state.survey)
    const [filterYear, setFilterYear] = useState('')
    const [listYear, setListYear] = useState([])

    useEffect(() => {
        const currentYear = new Date().getFullYear()
        let thn = []
        for (let i = 2024; i <= currentYear; i++) {
            thn.push(i)
        }
        setListYear(thn)
        setFilterYear(currentYear)
    }, [])

    useEffect(() => {
        if (filterYear !== '') {
            dispatch(onGetSurveyReport(1, filterYear))
            dispatch(onGetSurveyCount(filterYear))
        }
    }, [filterYear])

    useEffect(() => {
        let arrPenggunaan = []
        let arrPenilaian = {
            pertanyaan1: [],
            pertanyaan2: [],
            pertanyaan3: [],
            pertanyaan4: [],
            pertanyaan5: [],
            arrRata: [],
            rata: 0
        }
        let arrJenisPegawai = []
        let arrJenisKelamin = []
        let arrAge = []
        let arrDivision = []
        let arrPendidikan = []

        const apps = [
            "Regulasi",
            "Korespondensi",
            "Portal Pegawai",
            "Email",
            "Digital Sign",
            "Cuti",
            "SPPD",
            "Agenda/Kalender",
            "Task Management",
            "Repositori",
            "Chat",
            "Video Conference",
            "Helpdesk",
            "Pengetahuan",
            "Aksi Perubahan",
            "Sertifikat",
            "E-Learning"
        ];

        if (listCount !== null) {
            let charA = 65
            apps.map(item => {
                arrPenggunaan.push({
                    'Modul yang paling disukai': 0,
                    'Modul yang paling sering digunakan': 0,
                    'Modul yang sudah digunakan': 0,
                    name: String.fromCharCode(charA),
                    actualName: item,
                })
                charA++
            })

            arrPenggunaan.map((item, index) => {
                for (const keyPertanyaan in listCount['answer_counts']) {
                    if (keyPertanyaan.startsWith('Modul')) {
                        for (const keyApps in listCount['answer_counts'][keyPertanyaan]) {
                            if (item.actualName === keyApps) {
                                item[keyPertanyaan] = listCount['answer_counts'][keyPertanyaan][keyApps]
                            }
                        }
                    }
                }
            })

            for (const key in arrPenilaian) {
                for (let i = 1; i <= 5; i++) {
                    if (key !== 'arrRata' && key !== 'rata') {
                        arrPenilaian[key].push({
                            name: i === 1 ? 'Sangat Tidak Setuju' : i === 2 ? 'Tidak Setuju' : i === 3 ? 'Biasa Saja/Netral' : i === 4 ? 'Setuju' : 'Sangat Setuju',
                            value: 0
                        })
                    }
                }
            }

            let average = 0
            for (const key in listCount['answer_counts']) {
                for (const keyOpsi in listCount['answer_counts'][key]) {
                    if (key.includes('Portal Collaboration Office dapat diakses setiap hari')) {
                        arrPenilaian['pertanyaan1'][keyOpsi - 1].value = listCount['answer_counts'][key][keyOpsi]
                    } else if (key.includes('Informasi pada Portal Collabaration Office tersaji sesuai dengan kebutuhan')) {
                        arrPenilaian['pertanyaan2'][keyOpsi - 1].value = listCount['answer_counts'][key][keyOpsi]
                    } else if (key.includes('Akses login Portal Collaboration Office memiliki tingkat keamanan yang baik')) {
                        arrPenilaian['pertanyaan3'][keyOpsi - 1].value = listCount['answer_counts'][key][keyOpsi]
                    } else if (key.includes('Portal Collaboration Office dapat diakses dengan baik pada penjelajah (browser) saya')) {
                        arrPenilaian['pertanyaan4'][keyOpsi - 1].value = listCount['answer_counts'][key][keyOpsi]
                    } else if (key.includes('Portal Collaboration Office mudah digunakan')) {
                        arrPenilaian['pertanyaan5'][keyOpsi - 1].value = listCount['answer_counts'][key][keyOpsi]
                    }
                }
                if (key.startsWith('average')) {
                    average = average + listCount['answer_counts'][key]
                }
            }

            const tempAverage = average / 5

            arrPenilaian['arrRata'].push(
                {
                    name: 'Rata-rata',
                    value: parseFloat(tempAverage.toFixed(2)),
                },
                {
                    name: 'Sisa',
                    value: parseFloat((5 - tempAverage.toFixed(2)).toFixed(2)),
                },
            )

            arrPenilaian['rata'] = {
                koma: parseFloat(tempAverage.toFixed(2)),
                persen: ((parseFloat(tempAverage.toFixed(2)) * 100) / 5).toFixed(2)
            }

            for (const key in listCount['jenis_pegawai_counts']) {
                if (key !== 'null') {
                    arrJenisPegawai.push({
                        name: key,
                        value: listCount['jenis_pegawai_counts'][key]
                    })
                }
            }

            for (const key in listCount['jenis_kelamin_counts']) {
                if (key !== 'null') {
                    arrJenisKelamin.push({
                        name: key,
                        value: listCount['jenis_kelamin_counts'][key]
                    })
                }
            }

            let numA = 0
            let numB = 0
            let numC = 0
            for (const key in listCount['age_counts']) {
                if (key !== 'null') {
                    let number = parseInt(key)
                    if (number >= 21 && number <= 30) {
                        numA = numA + listCount['age_counts'][key]
                    } else if (number >= 31 && number <= 40) {
                        numB = numB + listCount['age_counts'][key]
                    } else if (number >= 41) {
                        numC = numC + listCount['age_counts'][key]
                    }
                }
            }
            arrAge.push(
                {
                    name: 'Usia 21 - 30',
                    value: numA
                },
                {
                    name: 'Usia 31 - 40',
                    value: numB
                },
                {
                    name: 'Usia 41 - Keatas',
                    value: numC
                }
            )

            charA = 65
            for (const key in listCount['division_counts']) {
                if (key !== 'null') {
                    arrDivision.push({
                        'Jumlah Pegawai': listCount['division_counts'][key],
                        name: String.fromCharCode(charA),
                        actualName: key,
                    })
                    charA++
                }
            }

            charA = 65
            for (const key in listCount['pendidikan_counts']) {
                if (key !== 'null') {
                    arrPendidikan.push({
                        'Jumlah Pegawai': listCount['pendidikan_counts'][key],
                        name: String.fromCharCode(charA),
                        actualName: key,
                    })
                    charA++
                }
            }

            setDataGraphPenggunaan(arrPenggunaan)
            setDataGraphPenilaian(arrPenilaian)
            setDataGraphJenisPegawai(arrJenisPegawai)
            setDataGraphJenisKelamin(arrJenisKelamin)
            setDataGraphUsia(arrAge)
            setDataGraphDivision(arrDivision)
            setDataGraphPendidikan(arrPendidikan)
        }
    }, [listCount])

    const handleExportSurvey = () => {
        dispatch({
            type: FETCH_START,
        });
        getSurveyExport(filterYear)
            .then(data => {
                const filename = 'Report Survei'
                const fileurl = data.results.file
                setLoadingProgress(true)
                axios({
                    url: fileurl,
                    method: 'GET',
                    responseType: 'blob',
                    onDownloadProgress: (progressEvent) => {
                        let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setProgress(percentCompleted)
                    }
                })
                    .then(response => {
                        dispatch({
                            type: FETCH_SUCCESS,
                        });
                        const url = window.URL.createObjectURL(response.data)
                        const link = document.createElement('a')

                        link.href = url
                        link.setAttribute(
                            'download', filename
                        )
                        document.body.appendChild(link)
                        link.click()
                        link.parentNode.removeChild(link);
                    })
                    .catch(() => {
                        const link = document.createElement('a');
                        link.href = fileurl;
                        link.setAttribute(
                            "download", filename
                        );
                        link.target = '_blank';
                        document.body.appendChild(link);
                        link.click();
                        link.parentNode.removeChild(link);
                    });
            })
            .catch(error => {
                dispatch({
                    type: FETCH_ERROR,
                    payload: 'Gagal mengunduh dashboard monitoring',
                });
                console.log(error)
            })
    }

    useEffect(() => {
        if (nProgress == 100) {
            setTimeout(() => {
                setLoadingProgress(false)
                setProgress(0)
            }, 1000)
        }
    }, [nProgress])

    return (
        <>
            <AppInfoView />

            <Stack
                gap={5}
                direction={'column'}
            >
                <Stack id='headerSurvey' sx={{ transition: '0.5s ease-in-out' }} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                    <Breadcrumbs aria-label='breadcrumb'>
                        <Typography
                            sx={{ cursor: 'pointer' }} color={'primary.default'}
                            variant='h3'
                            onClick={() => {
                                navigation(`/survey`)
                            }}
                        >
                            Survei Layanan Aplikasi Sistem Informasi
                        </Typography>
                        <Typography
                            sx={{ cursor: 'pointer', fontWeight: 'bold' }} color={'primary.default'}
                            variant='h3'
                            onClick={() => {
                                navigation(`/survey`)
                            }}
                        >
                            Hasil Survei
                        </Typography>
                    </Breadcrumbs>

                    <Stack
                        sx={{
                            '& label.Mui-focused': {
                                color: COLORS.primary,
                            },
                            '& .MuiOutlinedInput-root': {
                                '&:hover fieldset': {
                                    borderColor: grey[500],
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: COLORS.primary,
                                    color: COLORS.primary
                                },
                            },
                        }}
                    >
                        <FormControl sx={{ minWidth: 100 }} size="small">
                            <InputLabel id="filter-year">Tahun</InputLabel>
                            <Select
                                labelId="filter-year"
                                id="filter-year-id"
                                label="Tahun"
                                value={filterYear}
                                onChange={(e) => setFilterYear(e.target.value)}
                            >
                                {
                                    listYear.map((item, index) => (
                                        <MenuItem key={index} value={item}>{item}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Stack>
                </Stack>

                <AppCard title={'Grafik Data Penggunaan'} contentStyle={{ pl: 0 }}>
                    <MixBarChart
                        data={dataGraphPenggunaan}
                        dataKey={[
                            {
                                name: 'Modul yang paling disukai',
                                color: '#FF8F28',
                                stackId: 'a'
                            },
                            {
                                name: 'Modul yang paling sering digunakan',
                                color: '#16DBCC',
                                stackId: 'b'
                            },
                            {
                                name: 'Modul yang sudah digunakan',
                                color: '#B745FF',
                                stackId: 'c'
                            }
                        ]}
                    />
                </AppCard>

                <Grid container columnSpacing={5} rowSpacing={5}>
                    <Grid item xs={12} md={4}>
                        <AppCard sxStyle={{ height: '100%' }} contentStyle={{ pt: 0 }} title={
                            <Stack height={'90px'}>
                                <Box
                                    component='h3'
                                    sx={{
                                        color: 'text.primary',
                                        fontWeight: Fonts.SEMI_BOLD,
                                        fontSize: 16,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        width: '100%',
                                    }}
                                >
                                    Grafik Penilaian
                                </Box>
                                <Typography variant='caption'>[A] Akses login Portal Collaboration Office memiliki tingkat keamanan yang baik</Typography>
                                <Typography variant='body1' fontWeight={Fonts.SEMI_BOLD} mt={1}>Rata-rata <span style={{ marginLeft: 6 }}>{listCount === null ? 0 : listCount['answer_counts']['average Akses login Portal Collaboration Office memiliki tingkat keamanan yang baik'].toFixed(2)}</span></Typography>
                            </Stack>
                        }>
                            <MixPieChart data={dataGraphPenilaian.pertanyaan3} />
                        </AppCard>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <AppCard sxStyle={{ height: '100%' }} contentStyle={{ pt: 0 }} title={
                            <Stack height={'90px'}>
                                <Box
                                    component='h3'
                                    sx={{
                                        color: 'text.primary',
                                        fontWeight: Fonts.SEMI_BOLD,
                                        fontSize: 16,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        width: '100%',
                                    }}
                                >
                                    Grafik Penilaian
                                </Box>
                                <Typography variant='caption'>[B] Portal Collaboration Office mudah digunakan</Typography>
                                <Typography variant='body1' fontWeight={Fonts.SEMI_BOLD} mt={1}>Rata-rata <span style={{ marginLeft: 6 }}>{listCount === null ? 0 : listCount['answer_counts']['average Portal Collaboration Office mudah digunakan'].toFixed(2)}</span></Typography>
                            </Stack>
                        }>
                            <MixPieChart data={dataGraphPenilaian.pertanyaan5} />
                        </AppCard>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <AppCard sxStyle={{ height: '100%' }} contentStyle={{ pt: 0 }} title={
                            <Stack height={'90px'}>
                                <Box
                                    component='h3'
                                    sx={{
                                        color: 'text.primary',
                                        fontWeight: Fonts.SEMI_BOLD,
                                        fontSize: 16,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        width: '100%',
                                    }}
                                >
                                    Grafik Penilaian
                                </Box>
                                <Typography variant='caption'>[C] Informasi pada Portal Collabaration Office tersaji sesuai dengan kebutuhan</Typography>
                                <Typography variant='body1' fontWeight={Fonts.SEMI_BOLD} mt={1}>Rata-rata <span style={{ marginLeft: 6 }}>{listCount === null ? 0 : listCount['answer_counts']['average Informasi pada Portal Collabaration Office tersaji sesuai dengan kebutuhan'].toFixed(2)}</span></Typography>
                            </Stack>
                        }>
                            <MixPieChart data={dataGraphPenilaian.pertanyaan2} />
                        </AppCard>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <AppCard sxStyle={{ height: '100%' }} contentStyle={{ pt: 0 }} title={
                            <Stack height={'90px'}>
                                <Box
                                    component='h3'
                                    sx={{
                                        color: 'text.primary',
                                        fontWeight: Fonts.SEMI_BOLD,
                                        fontSize: 16,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        width: '100%',
                                    }}
                                >
                                    Grafik Penilaian
                                </Box>
                                <Typography variant='caption'>[D] Portal Collaboration Office dapat diakses dengan baik pada penjelajah (browser) saya</Typography>
                                <Typography variant='body1' fontWeight={Fonts.SEMI_BOLD} mt={1}>Rata-rata <span style={{ marginLeft: 6 }}>{listCount === null ? 0 : listCount['answer_counts']['average Portal Collaboration Office dapat diakses dengan baik pada penjelajah (browser) saya'].toFixed(2)}</span></Typography>
                            </Stack>
                        }>
                            <MixPieChart data={dataGraphPenilaian.pertanyaan4} />
                        </AppCard>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <AppCard sxStyle={{ height: '100%' }} contentStyle={{ pt: 0 }} title={
                            <Stack height={'90px'}>
                                <Box
                                    component='h3'
                                    sx={{
                                        color: 'text.primary',
                                        fontWeight: Fonts.SEMI_BOLD,
                                        fontSize: 16,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        width: '100%',
                                    }}
                                >
                                    Grafik Penilaian
                                </Box>
                                <Typography variant='caption'>[E] Portal Collaboration Office dapat diakses setiap hari</Typography>
                                <Typography variant='body1' fontWeight={Fonts.SEMI_BOLD} mt={1}>Rata-rata <span style={{ marginLeft: 6 }}>{listCount === null ? 0 : listCount['answer_counts']['average Portal Collaboration Office dapat diakses setiap hari'].toFixed(2)}</span></Typography>
                            </Stack>
                        }>
                            <MixPieChart data={dataGraphPenilaian.pertanyaan1} />
                        </AppCard>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <AppCard sxStyle={{ height: '100%' }} contentStyle={{ pl: 0 }} title={
                            <Stack>
                                <Box
                                    component='h3'
                                    sx={{
                                        color: 'text.primary',
                                        fontWeight: Fonts.SEMI_BOLD,
                                        fontSize: 16,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        width: '100%',
                                    }}
                                >
                                    Grafik Rata-rata
                                </Box>
                                <Typography variant='caption'>Data Penilaian</Typography>
                                <Typography variant='body1' fontWeight={Fonts.SEMI_BOLD} mt={1}>Rata-rata <span style={{ marginLeft: 6 }}>{listCount === null ? 0 : dataGraphPenilaian.rata.koma} atau sebesar  {listCount === null ? 0 : dataGraphPenilaian.rata.persen}%</span></Typography>
                            </Stack>
                        }>
                            <Stack height={1} alignItems={'center'} justifyContent={'center'}>
                                {/* <MixPieChart data={dataGraphPenilaian.arrRata} type='rata' /> */}
                                <AppCircularProgress maxWidth={'45%'} minWidth={'45%'} activeColor='#11C15B' value={dataGraphPenilaian.rata.persen} thickness={5} />
                            </Stack>
                        </AppCard>
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <AppCard title={'Grafik Data Unit Kerja'} contentStyle={{ pl: 0 }}>
                            <MixBarChart
                                data={dataGraphDivision}
                                dataKey={[
                                    {
                                        name: 'Jumlah Pegawai',
                                        color: '#B745FF',
                                        stackId: 'a'
                                    }
                                ]}
                            />
                        </AppCard>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <AppCard sxStyle={{ height: '100%' }} contentStyle={{ pl: 0 }} title={
                            <Stack>
                                <Box
                                    component='h3'
                                    sx={{
                                        color: 'text.primary',
                                        fontWeight: Fonts.SEMI_BOLD,
                                        fontSize: 16,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        width: '100%',
                                    }}
                                >
                                    Grafik Data Jenis Kelamin
                                </Box>
                            </Stack>
                        }>
                            <Stack height={1} alignItems={'center'} justifyContent={'center'}>
                                <MixPieChart data={dataGraphJenisKelamin} />
                            </Stack>
                        </AppCard>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <AppCard sxStyle={{ height: '100%' }} contentStyle={{ pl: 0 }} title={
                            <Stack>
                                <Box
                                    component='h3'
                                    sx={{
                                        color: 'text.primary',
                                        fontWeight: Fonts.SEMI_BOLD,
                                        fontSize: 16,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        width: '100%',
                                    }}
                                >
                                    Grafik Data Jenis Pegawai
                                </Box>
                            </Stack>
                        }>
                            <Stack height={1} alignItems={'center'} justifyContent={'center'}>
                                <MixPieChart data={dataGraphJenisPegawai} />
                            </Stack>
                        </AppCard>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <AppCard sxStyle={{ height: '100%' }} contentStyle={{ pl: 0 }} title={
                            <Stack>
                                <Box
                                    component='h3'
                                    sx={{
                                        color: 'text.primary',
                                        fontWeight: Fonts.SEMI_BOLD,
                                        fontSize: 16,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        width: '100%',
                                    }}
                                >
                                    Grafik Data Usia
                                </Box>
                            </Stack>
                        }>
                            <Stack height={1} alignItems={'center'} justifyContent={'center'}>
                                <MixPieChart data={dataGraphUsia} />
                            </Stack>
                        </AppCard>
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <AppCard title={'Grafik Data Pendidikan'} contentStyle={{ pl: 0 }}>
                            <MixBarChart
                                data={dataGraphPendidikan}
                                dataKey={[
                                    {
                                        name: 'Jumlah Pegawai',
                                        color: '#16DBCC',
                                        stackId: 'a'
                                    }
                                ]}
                            />
                        </AppCard>
                    </Grid>
                </Grid>

                <AppCard contentStyle={{ p: 0 }}>
                    {
                        loadingProgress &&
                        <Stack>
                            <LinearProgressBar
                                variant="determinate"
                                value={nProgress} />
                        </Stack>
                    }
                    <Stack p={6} spacing={2}>
                        <Stack>
                            <Box
                                component='h3'
                                sx={{
                                    color: 'text.primary',
                                    fontWeight: Fonts.SEMI_BOLD,
                                    fontSize: 16,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    width: '100%',
                                }}
                            >
                                List Survei
                            </Box>
                        </Stack>
                        <ListSurvey handleExportSurvey={handleExportSurvey} />
                    </Stack>
                </AppCard>
            </Stack >
        </>
    )
}

export default HasilSurvey